export default function Footer() {
  return (
    <footer className="footer">
      © {new Date().getFullYear()} Albert Seo ·
    </footer>
  );
}
